if ($(".in-index").length) {
    $(document).ready(function () {
        /**
         * ==============================
         * CAROUSEL INDICATORS
         * ==============================
         */
        $(".carousel").each(function () {
            const $carousel = $(this);
            const id = $carousel.attr("id");
            if (!id) return;

            if (!$carousel.find(".carousel-indicators").length) {
                $carousel.append("<ol class='carousel-indicators'></ol>");
            }

            const $indicators = $carousel.find(".carousel-indicators");
            $indicators.empty();

            $carousel.find(".carousel-inner > .item").each(function (index) {
                $indicators.append(`
           <li data-target="#${id}"
                        data-slide-to="${index}"
                        class="${index === 0 ? "active" : ""}">
                    </li>
  `);
            });


        });
    });

    $(function () {
        setBannerTextColorFromAlt();
    });
}




 function setBannerTextColorFromAlt() {
    $('.carousel-inner .item').each(function () {
        var $item = $(this);
        var $img = $item.find('img').first();
        var $texts = $item.find('.extended-banner-texts');

        if (!$img.length || !$texts.length) return;

        var alt = $img.attr('alt') || '';

        $texts.removeClass('isTextWhite isTextBlack isTextGreen');

        if (alt.indexOf('isTextWhite') !== -1) {
            $texts.addClass('isTextWhite');
        } else if (alt.indexOf('isTextBlack') !== -1) {
            $texts.addClass('isTextBlack');
        } else if (alt.indexOf('isTextGreen') !== -1) {
            $texts.addClass('isTextGreen');
        } else {
            // fallback, když v altu není žádná třída
            $texts.addClass('isTextWhite');
        }
    });
}